import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
import axios from 'axios';
import i18n from './i18n';
import './plugins/vuetify-money.js';

axios.defaults.baseURL = 'https://backpetbrief.gtsf.com.mx';
//axios.defaults.baseURL = 'http://arqibero.gtsf.com.mx';
//axios.defaults.baseURL = 'http://192.168.1.66:9816';
//baseURL: 'http://172.22.128.136:9539'

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
